export const VIDEO_BANNER_DISMISSED_SESSION_STORAGE = 'videoBannerDismissed'
